import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { AtlasBannerRef } from '@wellsky/atlas-ui/banners';

@Component({
  selector: 'app-banner-demo-t1',
  templateUrl: './banner-demo-t1.component.html',
})
export class BannerDemoT1Component {
  imageUrl: string;

  constructor(private route: Router, private bannerRef: AtlasBannerRef<BannerDemoT1Component>) {
    this.imageUrl = '../../../assets/images/banner_icon.png';
  }

  /**
   * Perform Dismiss Action for Banner
   */
  getDismissAction() {
    // Trigger close for banner
    this.bannerRef.close();
  }

  /**
   * Perform Action on Banner
   */
  performAction() {
    // Trigger close for banner
    this.bannerRef.close();

    // Perform action on banner
    this.route.navigateByUrl('/components/buttons/develop/overview');
  }
}
